import styled from 'styled-components';
import { themeOptions } from 'styles/theme';

export const StyledTextArea = styled.div`
  position: relative;

  span {
    font-weight: 600;
  }

  .ta-label {
    display: flex;
    align-items: center;
    position: relative;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
    }
  }

  .MuiOutlinedInput-root {
    width: ${(props) => (props.width ? props.width : null)};
    height: ${(props) => (props.height ? props.height : '180px')};
    padding: 9px 12px;
    background-color: ${themeOptions.palette.white.main};
    border: 1px solid #dadada;
    border-radius: 6px;

    &:hover {
      box-shadow: 0 0 0 3px var(--color-off-white);
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid #dadada;
      }
    }
    &:active {
      box-shadow: none !important;
      border-color: var(--color-pale-gray);
    }

    .MuiOutlinedInput-input {
      width: 100%;
      height: 100% !important;
      padding: 0;
      overflow-y: auto !important;
      border-radius: 6px;
      outline: none;
      appearance: none;
      background-color: ${themeOptions.palette.white.main};

      &:disabled {
        background-color: ${themeOptions.palette.gray.light};
      }
    }
  }

  /* required 경우, disabled style */
  .MuiOutlinedInput-root.Mui-disabled {
    background-color: ${themeOptions.palette.gray.light};
  }
`;
